export enum AdvanceSetupTabs {
    accountSetup = "accountSetup",
    imageAds = "ads"
}